import { useEffect, useState } from "react";

// Single source of truth for the plugin version is /downloads/version.json
// on the same host (served by nginx). Each plugin release uploads the new
// pkg + this file, so the website auto-updates on next page load.
let cached = null;
let inflight = null;

async function fetchVersion() {
  if (cached) return cached;
  if (!inflight) {
    inflight = fetch("/downloads/version.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { cached = j; return j; })
      .catch(() => null)
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function useDownloadVersion() {
  const [info, setInfo] = useState(cached);
  useEffect(() => {
    if (cached) return;
    fetchVersion().then(setInfo);
  }, []);
  return info; // { version, released_at } or null while loading / on error
}
